import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import apiConfig from '../config/apiConfig';

function AzureIndicators() {
  const [azureCost, setAzureCost] = useState("--");
  const [azureCurrency, setAzureCurrency] = useState("zł");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAzureCosts = async () => {
      try {
        setIsLoading(true);
        
        const costUrl = `${apiConfig.azureFunctionsBaseUrl}${apiConfig.endpoints.azureCosts}`;
        const response = await fetch(costUrl);
        
        if (!response.ok) {
          throw new Error(`Error fetching Azure costs: ${response.statusText}`);
        }
        
        const data = await response.json();
        
        setAzureCost(data.totalCost.toFixed(2));
        setAzureCurrency(data.currency || "EUR");
        setError(null);
      } catch (err) {
        console.error("Failed to fetch Azure costs:", err);
        setError("Failed to fetch Azure costs");
      } finally {
        setIsLoading(false);
      }
    };

    fetchAzureCosts();
    const intervalId = setInterval(fetchAzureCosts, 10 * 60 * 1000);
    
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="azure-indicators py-2" style={{ 
      background: 'linear-gradient(90deg, #0078D4 0%, #1E3A8A 100%)',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      display: 'none' // Temporarily disabled
    }}>
      <Container>
        <Row className="g-2 justify-content-center align-items-center">
          <Col xs="auto">
            <div className="d-flex align-items-center px-3 py-2 rounded-pill" 
                 style={{ 
                   background: 'rgba(255,255,255,0.15)',
                   backdropFilter: 'blur(10px)',
                   border: '1px solid rgba(255,255,255,0.2)'
                 }}>
              <div className={`pulse-dot me-2 ${isLoading ? 'loading' : ''}`}></div>
              <small className="text-white fw-bold me-2">Azure Cost</small>
              <Badge bg="light" text="dark" className="px-3">
                {error ? "--" : `${azureCost} ${azureCurrency}`}
              </Badge>
            </div>
          </Col>
          
          {/* Disabled indicators - kept for future use */}
          {/* 
          <Col xs="auto">
            <div className="d-flex align-items-center px-3 py-2 rounded-pill" 
                 style={{ 
                   background: 'rgba(255,255,255,0.15)',
                   backdropFilter: 'blur(10px)',
                   border: '1px solid rgba(255,255,255,0.2)'
                 }}>
              <div className="pulse-dot me-2"></div>
              <small className="text-white fw-bold me-2">Pipeline</small>
              <Badge bg="success">Successful</Badge>
            </div>
          </Col>
          
          <Col xs="auto">
            <div className="d-flex align-items-center px-3 py-2 rounded-pill" 
                 style={{ 
                   background: 'rgba(255,255,255,0.15)',
                   backdropFilter: 'blur(10px)',
                   border: '1px solid rgba(255,255,255,0.2)'
                 }}>
              <div className="pulse-dot me-2"></div>
              <small className="text-white fw-bold me-2">Uptime</small>
              <Badge bg="light" text="dark">99.8%</Badge>
            </div>
          </Col>
          
          <Col xs="auto">
            <div className="d-flex align-items-center px-3 py-2 rounded-pill" 
                 style={{ 
                   background: 'rgba(255,255,255,0.15)',
                   backdropFilter: 'blur(10px)',
                   border: '1px solid rgba(255,255,255,0.2)'
                 }}>
              <div className="pulse-dot me-2"></div>
              <small className="text-white fw-bold me-2">CV Downloads</small>
              <Badge bg="light" text="dark">243</Badge>
            </div>
          </Col>
          */}
        </Row>
      </Container>
      
      <style>
        {`
          .pulse-dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #50C878;
            box-shadow: 0 0 8px rgba(80, 200, 120, 0.8);
            animation: pulse 2s infinite;
          }
          
          .pulse-dot.loading {
            background: #FFA500;
            animation: pulse 1s infinite;
          }
          
          @keyframes pulse {
            0% {
              transform: scale(0.95);
              box-shadow: 0 0 0 0 rgba(80, 200, 120, 0.7);
            }
            70% {
              transform: scale(1);
              box-shadow: 0 0 0 5px rgba(80, 200, 120, 0);
            }
            100% {
              transform: scale(0.95);
              box-shadow: 0 0 0 0 rgba(80, 200, 120, 0);
            }
          }
        `}
      </style>
    </div>
  );
}

export default AzureIndicators;